import { AdminUserConstant } from '../actions/constants/AdminUserConstant';
// IMP-377: 사용자 목록 adminid 순 정렬 comparator (SSoT). DeepSearch 사용자 필터가 adminid 를 표시하므로 표시 데이터 기준 정렬.
const byAdminId = (a, b) => String(a?.adminid || '').localeCompare(String(b?.adminid || ''));
const initialState = {
	users: [],
	usersrecursive: [],
	user: {},
	filter: {},
	isUpdateRes: false,
	isLoading: false,
};
export const AdminUserReducer = (state = initialState, action) => {
	switch (action.type) {
		case AdminUserConstant.GETUSERINFO_SUCCESS:
			return {
				...state,
				user: action.user,
				users: state.users.map((u) => (u._id == action.user._id ? action.user : u)),
				isUpdateRes: false
			};
		case AdminUserConstant.UPDATE_USERINFO: {
			// PR #185 R2 — backend 응답이 변경된 필드만 반환하는 경우(예: {permAdminAccess: false})
			// user state 를 통째로 부분 객체로 덮어쓰면 firstName/email 등 다른 필드가 모두 사라져
			// form 이 빈 값으로 재렌더되고 체크박스가 원복된 것처럼 보이는 회귀 발생.
			// → 무조건 기존 state.user 와 응답을 머지. 응답이 전체 user 객체여도 동일 결과.
			const incoming = action.user || {};
			const mergedUser = { ...(state.user || {}), ...incoming };
			const matchKey = mergedUser._id ?? mergedUser.adminid;
			return {
				...state,
				user: mergedUser,
				isUpdateRes: true,
				// IMP-377: 목록 멤버십 변경(append) 시에도 adminid 정렬 불변식 유지
				users: matchKey
					? (state.users.some((n) => (n._id ?? n.adminid) === matchKey)
						? state.users.map((n) => (
							(n._id ?? n.adminid) === matchKey ? { ...n, ...incoming } : n
						))
						: [...state.users, mergedUser]).sort(byAdminId)
					: state.users,
			};
		}
		case AdminUserConstant.DELETE_USER:
			return { ...state, users: state.users.filter((u) => u._id !== action.deluserid), isUpdateRes: true };
		case AdminUserConstant.CLEAR_UPDATERES:
			return { ...state, isUpdateRes: false };
		case AdminUserConstant.REGIST_USERINFO:
			return {
				...state,
				// IMP-377: adminid 정렬 불변식 — 추가 시 정렬 위치에 삽입
				users: [...state.users, action.user].sort(byAdminId),
				isUpdateRes: true
			};
		case AdminUserConstant.GET_USERLIST:
			// IMP-377: adminid 정렬 불변식 — 목록 로드 시 정렬 (원본 action.users 불변)
			return { ...state, users: [...(action.users || [])].sort(byAdminId), isUpdateRes: false };
		case AdminUserConstant.LOADING:
			return { ...state, isLoading: true }
		case AdminUserConstant.LOADED:
			return { ...state, isLoading: false }
		default:
			return state;
	}
};
